/* Created By CoolGuy on 2017/12/1
 */
import React from "react";
import imageAction from "../../actions/image";
import { observer } from "mobx-react";
import PinchZoom from "pinch-zoom-js";
import Wrapper from "./PinchZoomSuperWrapper";
import { isWeb } from "../../utils/util";
import { direct } from "../../utils/image";
import "./PinchZoomWrapper.scss";
import { BIGPIC_PRELOAD_LENGTH } from "./AllForBigPic";

let THUMB_LOAD_MAP = {};

@observer
class PinchZoomWrapper extends React.Component {
  loadThumb = (e) => {
    // 目前的方案上，长图不需要设置高度100vh，否则会出现屏幕显示不下的问题
    // if (this.thumb && isWeb()) {
    //   const { clientWidth, clientHeight } = document.documentElement;
    //   const clientRatio = clientWidth / clientHeight;
    //   const { width, height } = this.thumb;
    //   const ratio = width / height;
    //   // console.log(ratio, clientRatio);
    //   if (ratio < clientRatio) {
    //     // 去掉不需要的多余的部分的设置
    //     // this.img.parentNode.style.height = '100vh';
    //     // this.img.parentNode.style.width = '100%';
    //     // this.img.style.position = 'inherit';
    //     this.thumb.style.height = '100vh';
    //     this.thumb.style.width = 'auto';
    //   }
    // }
    //
    // // 在显示超长图片的时候，需要先从头部开始显示，而不是居中显示
    // if (!!this.props.disablePinchZoom && this.thumb && this.thumb.parentNode) {
    //   if (
    //     this.thumb.height > this.thumb.width &&
    //     this.thumb.height > window.innerHeight
    //   )
    //     this.thumb.parentNode.style.height = '100vh';
    //   this.thumb.parentNode.style.overflow = 'auto';
    // }
    // if(this.img && !this.img.__loadimg) {
    if (this.img && !THUMB_LOAD_MAP[this.props.src]) {
      if (this.thumbLoading) {
        this.thumbLoading.style.opacity = 1;
      }
      this.loadImg(e);
      let image = new Image();
      image.onload = () => {
        if (this.img) {
          // this.img.__loadimg = true;
          THUMB_LOAD_MAP[this.props.src] = true;
          this.img.src = this.props.src;
        }

        if (this.thumbLoading) {
          this.thumbLoading.style.opacity = 0;
        }
      };
      image.src = this.props.src;
    }
  };

  loadError = (e) => {
    this.props.loadError && this.props.loadError();
  }

  loadImg = (e) => {
    // 目前的方案上，长图不需要设置高度100vh，否则会出现屏幕显示不下的问题
    // console.log(`load Success`, e);
    if (this.img && isWeb()) {
      const { clientWidth, clientHeight } = document.documentElement;
      const clientRatio = clientWidth / clientHeight;
      const { width, height } = this.img;
      const ratio = width / height;
      // console.log(ratio, clientRatio);
      if (ratio < clientRatio) {
        // 去掉不需要的多余的部分的设置
        // this.img.parentNode.style.height = '100vh';
        // this.img.parentNode.style.width = '100%';
        // this.img.style.position = 'inherit';
        this.img.style.height = "var(--vh)";
        this.img.style.width = "auto";
      }
    }

    // this.img.className = (this.img.className || '').replace('opacity-0', '');
    if (this.props.data && this.props.data.loadStatus === "loading") {
      this.fetchSize();
    }

    // 在显示超长图片的时候，需要先从头部开始显示，而不是居中显示
    if (!!this.props.disablePinchZoom && this.img && this.img.parentNode) {
      if (
        this.img.height > this.img.width &&
        this.img.height > window.innerHeight
      )
        this.img.parentNode.style.height = "var(--vh)";
      this.img.parentNode.style.overflow = "auto";
    }

    let _img = this.img;
    // window.setTimeout(()=>{
    //   _img.style.opacity = 1;
    // }, 1);
    _img.style.opacity = 1;
  };
  fetchSize() {
    imageAction.size(this.props.src).then((res) => {
      // if (res) {
      // this.props.data.size = res;
      if (this.props.loadFinish) {
        this.props.loadFinish(res);
      }
      // }
    });
  }

  setPinchZoom(props) {
    const { currentImageIndex, index } = props;
    // console.log('set pinch zoom', currentImageIndex, index);
    if (currentImageIndex !== undefined && currentImageIndex !== -1) {
      // 当前和当前前后1个做处理
      // if (Math.abs(index - currentImageIndex) < 4) {
      if (this.img.parentNode) {
        //console.log(this.img.parentNode.classList);
        const { classList = [] } = this.img.parentNode;
        //const index = Array.prototype.findIndex.call(classList,(one)=>{return one==='pinch-zoom-container'})
        const findIndex = Array.prototype.findIndex.call(
          classList,
          (one) => one === "pinch-zoom-container"
        );
        //只有找不到父级节点包含pinch-zoom-container  才需要new一个，否则说明已经new过了
        if (findIndex === -1 && this.img) {
          if (!isWeb()) {
            this.instance = new PinchZoom(this.img, {
              draggableUnzoomed: false, // 相关事件会向上触发，如果是false，滑动大图等事件会被阻止掉
              setOffsetsOnce: true, //必须是true，否则加载完大图后会出现位置不准确的问题
              onZoomStart:
                props.onZoomStart
                  ? (...args) =>
                      this.props.onZoomStart &&
                      this.props.onZoomStart(index, ...args)
                  : undefined,
            });

            // onZoomStart:props.onZoomStart && props.onZoomStart.bind(this, currentImageIndex)
            // window.removeEventListener(
            //   'swipeIndex' + index,
            //   this.indexChange
            // );
            // window.addEventListener('swipeIndex' + index, this.indexChange);
            // window.addEventListener('pz_dragstart', function(e) {
            //   console.log('pz_start');
            //   e.stopPropagation();
            // });
            // window.addEventListener('pz_dragend', function(e) {
            //   console.log('pz_dragend');
            //   //这里的阻止貌似没用，不过不影响，先放着
            //   e.stopPropagation();
            // });
          }
        }
      }
      // }
    }
  }

  // componentDidUpdate(prevProps) {
  //   // 每个PinchZoomWrapper都会mount一次，不需要重新setPinchZoom
  //   if (!this.props.disablePinchZoom) this.setPinchZoom(this.props);
  // }
  componentWillReceiveProps(nextProps, nextContext) {
    // console.log(nextProps, this.props, 'receive');
    // if (nextProps.currentImageIndex !== this.props.currentImageIndex) {
    //   window.dispatchEvent(
    //     new Event('swipeIndex' + this.props.currentImageIndex)
    //   );
    // }
    // if(String(this.props.mode) == 'waterfall') {
    //   if(nextProps.src != this.props.src && this.img && this.img.__loadimg) {
    //     this.img.src = nextProps.src;
    //   }
    // }
  }

  componentDidMount() {
    // console.log('mount');
    if (!this.props.disablePinchZoom) this.setPinchZoom(this.props);
  }
  componentWillUnmount() {
    // window.removeEventListener(
    //   'swipeIndex' + this.props.index,
    //   this.indexChange
    // );
  }

  indexChange = (e) => {
    // 在切换时，需要重置上一个界面的缩放，由于没有提供这样的api，所以只能手动设置相关值了，垃圾
    // if (this.instance) {
    //   this.instance.zoomFactor = 1;
    //   this.instance.offset = {
    //     x: 0,
    //     y: 0
    //   };
    //   this.instance.update();
    // }
  };

  render() {
    const { props } = this;
    const { index, currentImageIndex, hideBigPic, thumb, mode, src, data } =
      props;
    if (!props.src) {
      return null;
    }
    // console.log('render pinch zoom');
    var lazyload = Math.abs(currentImageIndex - index) > BIGPIC_PRELOAD_LENGTH;
    const useThumb = !THUMB_LOAD_MAP[src] && !!thumb && String(mode) == 'waterfall' && currentImageIndex == index && data && !data.loadStatus;

    const targetSrc = useThumb ? thumb : src;
    const targetOnLoad = useThumb ? this.loadThumb : this.loadImg;
    return !!props.disablePinchZoom ? (
      <img
        ref={(name) => {
          this.img = name;
        }}
        alt={""}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onLoad={this.loadImg}
        src={lazyload ? direct(`static/blank.png`) : props.src}
        className="big-pic-main-image opacity-0"
        style={{ width: "100%" }}
      />
    ) : (
      <>
        <Wrapper hideBigPic={hideBigPic} onLongPress={this.props.onLongPress}>
          {/*String(mode) == 'waterfall' ? <img ref={name=>{
            this.thumb = name;
          }} src={props.thumb} className="big-pic-main-thumb" onLoad={this.loadThumb} /> : null*/}
          <img
            ref={(name) => {
              this.img = name;
            }}
            alt={""}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onLoad={lazyload ? () => { } : targetOnLoad}
            src={lazyload ? direct(`static/blank.png`) : targetSrc}
            // className="big-pic-main-image opacity-0"
            className="big-pic-main-image"
            style={{ width: "100%", opacity: 0 }}
            onError={this.loadError}
          />
          {useThumb ? <img ref={(loading) => {
            this.thumbLoading = loading;
          }} className="waterfall-loading" src={'//image1.jimage.cn/static/loading_bigpic.gif'} /> : null}
        </Wrapper>
      </>
    );
  }
}
export default PinchZoomWrapper;
